import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const ReduceAbsenteeism5 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="reduceAbsenteeism" section="afterPattern">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="reduceAbsenteeism:afterPattern" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default ReduceAbsenteeism5;
